import { Injectable } from '@angular/core';
import { AuthService } from '../../../../../src/app/auth/auth.service';

@Injectable({ providedIn: 'root' })
export class BuyerContextService {
  constructor(private _auth: AuthService) {}

  get token(): string {
    if (this._auth.isSelectedMultiBuyerCompany()) {
      return this._auth.selectedMultiBuyerCompany!.token ?? this._auth.token!;
    }

    if (this._auth.isLoggedInAsServiceBuyer()) {
      return this._auth.serviceBuyer!.token ?? this._auth.token!;
    }

    return this._auth.token!;
  }

  get companyId(): number {
    if (this._auth.isSelectedMultiBuyerCompany()) {
      return this._auth.selectedMultiBuyerCompany!.id;
    }

    if (this._auth.isLoggedInAsServiceBuyer()) {
      return this._auth.serviceBuyer!.id;
    }

    return this._auth.user!.cmp;
  }

  get userId(): number {
    if (this._auth.isSelectedMultiBuyerCompany()) {
      return (
        this._auth.selectedMultiBuyerCompany!.userId ?? this._auth.user!.id
      );
    }

    return this._auth.user!.id;
  }
}
